import { useCombobox } from 'downshift-v9';

export const srKeepOnBlur = options => {
  const { resetHighlightOnClear = false } =
    typeof options === 'object' ? options : {};

  return (state, actionAndChanges) => {
    const { changes, type } = actionAndChanges;

    switch (type) {
      case useCombobox.stateChangeTypes.InputBlur:
        return { ...changes, inputValue: state.inputValue };
      case useCombobox.stateChangeTypes.InputKeyDownEscape:
        return { isOpen: false, inputValue: state.inputValue };
      case useCombobox.stateChangeTypes.InputChange:
        if (resetHighlightOnClear && !changes.inputValue?.trim()) {
          return { ...changes, highlightedIndex: 0 };
        }
        return changes;
      default:
        return changes;
    }
  };
};

export const srClearOnBlur = (state, actionAndChanges) => {
  const { type, changes } = actionAndChanges;
  if (type === useCombobox.stateChangeTypes.InputBlur) {
    return {
      ...changes,
      inputValue: '',
    };
  }
  return changes;
};
